// extracted by mini-css-extract-plugin
module.exports = {"title":"privacy-policy_title_TVd3W","updated":"privacy-policy_updated_3ynsl","heading":"privacy-policy_heading_1CKiC"};